import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SwiperComponent, SwiperModule } from 'swiper/angular';


@Component({
  selector: 'mnf-slider-view',
  standalone: true,
  imports: [SwiperModule, CommonModule],
  templateUrl: './slider-view.component.html',
  styleUrl: './slider-view.component.scss'
})
export class SliderViewComponent {
  @Output() next = new EventEmitter();

  firstTimeApp: boolean = true;

  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  currentSlideIndex = 0;

  items = [
    { imagen: 'https://static.monific.com/assets/assets-app/sliders/slider_01.webp', icon: 'https://static.monific.com/assets/assets-app/sliders/key-icon.svg', subtitle: 'Oportunidades a tu alcance', texto: 'Invierte de forma fácil, segura y accesible en proyectos inmobiliarios seleccionados.', button: 'Continuar', display: 'hidden' },
    { imagen: 'https://static.monific.com/assets/assets-app/sliders/slider_2.webp', icon: 'https://static.monific.com/assets/assets-app/sliders/lock-icon.svg', subtitle: 'Somos una plataforma regulada', texto: 'Autorizados, supervisados y regulados por la CNBV, Banco de México y Condusef.', button: 'Continuar', display: 'hidden' },
    { imagen: 'https://static.monific.com/assets/assets-app/sliders/slider_3.webp', icon: 'https://static.monific.com/assets/assets-app/sliders/wallet-icon.svg', subtitle: 'Genera rendimientos atractivos', texto: 'Obtén rendimientos anuales fijos desde 15%. ¡Tu inversión respaldada por inmuebles!', button: 'Continuar', display: 'hidden' },
    { imagen: 'https://static.monific.com/assets/assets-app/sliders/slider_4.webp', icon: 'https://static.monific.com/assets/assets-app/sliders/pig_icon.png', subtitle: '¡Tu camino hacia la libertad financiera!', texto: 'Genera ingresos mientras disfrutas de tu tiempo libre. Explora las oportunidades y comienza a crear un futuro financiero sólido.', button: 'Iniciar sesión', button2: 'Crear cuenta' },
  ];

  goToNextSlide(index: number): void {
    if (this.swiper && this.swiper.swiperRef) {
      this.swiper.swiperRef.slideTo(index);
    }
  }

  redirectToURL(destination: string): void {
    this.firstTimeApp = false;
    let toSend = { firstTimeApp: this.firstTimeApp, link: destination };
    this.next.next(toSend);
  }

  
}
